import { ActionItem, useUpdateActionItem } from "@portal/api/action-item/admin";
import { Label, QuickEditLabel } from "@portal/components/ui/Label";
import { useActionItemsSelection } from "@portal/providers/ActionItemsSelectionProvider";
import { HiOutlineNewspaper } from "react-icons/hi2";

export const ActionItemTitleDisplay = ({
	actionItem,
	completed,
}: {
	actionItem: ActionItem;
	completed: boolean;
}) => {
	const { selectedActionItemId } = useActionItemsSelection();
	const { updateTitle } = useUpdateActionItem();
	const isSelected = selectedActionItemId === actionItem.id;

	return (
		<div className="w-full">
			{completed ? (
				<Label
					size="small"
					bold
					strike
					iconAfter={!isSelected && actionItem.content && <HiOutlineNewspaper size={16} />}
				>
					{actionItem.title}
				</Label>
			) : (
				<QuickEditLabel
					size="small"
					bold
					onTextChange={(newTitle) => updateTitle(actionItem, newTitle)}
					iconAfter={!isSelected && actionItem.content && <HiOutlineNewspaper size={16} />}
				>
					{actionItem.title}
				</QuickEditLabel>
			)}
		</div>
	);
};
